import { MessagesStateShape } from 'store';

export default {
	globalMessages: []
} as MessagesStateShape;
